"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualLibraryFixTemporaryStyled = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
/**
 * Esse arquivo deve ser removido assim que o lift disponibilizar o icone correto.
 */
exports.VirtualLibraryFixTemporaryStyled = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    stroke: ", ";\n  }\n\n  svg path {\n    stroke-width: 1.5px;\n  }\n\n  svg line {\n    stroke-width: 1.5px;\n  }\n"], ["\n  svg {\n    stroke: ", ";\n  }\n\n  svg path {\n    stroke-width: 1.5px;\n  }\n\n  svg line {\n    stroke-width: 1.5px;\n  }\n"])), function (props) { return props.theme.black; });
var templateObject_1;
